import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { pushToDataLayer } from '../gaTracker';
import { getSectionCategorySubCat } from '../getSectionCategorySubCat';
import { mobileAppUtil } from '../../mobileAppUtil';
export var ecommClick = function ecommClick(product) {
  var _product$item;

  var categories = getSectionCategorySubCat(product === null || product === void 0 ? void 0 : product.detailLink);
  var ecommerceObj = (mobileAppUtil === null || mobileAppUtil === void 0 ? void 0 : mobileAppUtil.isMobileApp()) ? {
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list: 'PLP'
        },
        products: [{
          name: product === null || product === void 0 ? void 0 : product.name,
          id: product === null || product === void 0 ? void 0 : product.id,
          price: product === null || product === void 0 ? void 0 : product.price,
          section: categories[0] || '',
          category: categories[1] || '',
          'dimension1': categories[2] || '',
          'dimension2': categories[3] || '',
          'dimension3': 'In stock',
          'dimension4': (product === null || product === void 0 ? void 0 : product.collection) || '',
          'dimension5': (product === null || product === void 0 ? void 0 : product.catalog) || '',
          'dimension6': 'Regular Price',
          'variant': (product === null || product === void 0 ? void 0 : product.variants) || '',
          'position': 1
        }]
      }
    }
  } : {
    event: 'select_item',
    detailed_event: 'Select Item',
    ecommerce: {
      items: [_objectSpread(_objectSpread({}, product === null || product === void 0 ? void 0 : product.item), {}, {
        item_category: categories[0],
        item_category2: categories[1],
        item_category3: categories[2],
        item_category4: categories[3],
        item_category5: categories[4]
      })],
      value: (product === null || product === void 0 ? void 0 : (_product$item = product.item) === null || _product$item === void 0 ? void 0 : _product$item.value) || 0
    }
  }; // Clear out the ecomm object first

  pushToDataLayer({
    ecommerce: null
  });
  pushToDataLayer(ecommerceObj);
};